import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { BatchCreateChannelMembershipResponseFilterSensitiveLog, } from "../models/models_0";
import { de_BatchCreateChannelMembershipCommand, se_BatchCreateChannelMembershipCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class BatchCreateChannelMembershipCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "BatchCreateChannelMembership", {})
    .n("ChimeSDKMessagingClient", "BatchCreateChannelMembershipCommand")
    .f(void 0, BatchCreateChannelMembershipResponseFilterSensitiveLog)
    .ser(se_BatchCreateChannelMembershipCommand)
    .de(de_BatchCreateChannelMembershipCommand)
    .build() {
}
